// src/components/NoticePopup/index.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'antd';
import SafeHtml from '@components/SafeHtml';
import { NoticeContent } from './styled';

const mapState = (state) => ({
  latestNotice: state.notice.latestNotice,
  unreadCount: state.notice.unreadList.length,
});

const mapDispatch = (dispatch) => ({
  markRead: dispatch.notice.markNoticeRead,
});

const NoticePopup = ({ latestNotice, unreadCount, markRead }) => {
  const [visible, setVisible] = React.useState(false);
  const processedIdsRef = React.useRef(new Set());

  // 监听 latestNotice 变化，有新未读通知时自动显示弹窗
  React.useEffect(() => {
    if (latestNotice && !processedIdsRef.current.has(latestNotice.id)) {
      setVisible(true);
    }
  }, [latestNotice?.id]);

  const handleConfirm = async () => {
    if (latestNotice) {
      await markRead(latestNotice.id);
      processedIdsRef.current.add(latestNotice.id);
      // 等 Redux 更新后，通过检查 unreadCount 来判断是否需要关闭
      // 如果还有未读，不关闭，让 useEffect 处理下一条
      // 如果没有未读了，关闭弹窗
      if (unreadCount <= 1) {
        setVisible(false);
      }
    }
  };

  // 无通知时不渲染
  if (!latestNotice) return null;

  // 计算当前是第几条
  const currentIndex = unreadCount;
  const hasMore = currentIndex > 1;

  return (
    <Modal
      visible={visible}
      title={latestNotice.title}
      footer={[
        <Button key="confirm" type="primary" onClick={handleConfirm}>
          {hasMore ? `确认已读 (还剩${currentIndex - 1}条)` : '确认已读'}
        </Button>,
      ]}
      closable={false}
      width={480}
      centered
    >
      <NoticeContent>
        <SafeHtml content={latestNotice.content} />
      </NoticeContent>
      {latestNotice.create_time && (
        <div style={{ fontSize: 12, color: '#999', marginTop: 12 }}>
          发布时间：{latestNotice.create_time}
        </div>
      )}
      {hasMore && (
        <div style={{ fontSize: 12, color: '#1890ff', marginTop: 8 }}>
          还有 {currentIndex - 1} 条未读，确认后自动显示下一条
        </div>
      )}
    </Modal>
  );
};

NoticePopup.propTypes = {
  latestNotice: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    content: PropTypes.string,
    create_time: PropTypes.string,
  }),
  markRead: PropTypes.func,
  unreadCount: PropTypes.number,
};

export default connect(mapState, mapDispatch)(NoticePopup);
